import React, { useContext, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as EventSvg } from '../assets/event.svg';
import { ReactComponent as PersonSvg } from '../assets/person.svg';
import { ReactComponent as LogoutSvg } from '../assets/logout.svg';
import { ReactComponent as DropdownSvg } from '../assets/user_dropdown_arrow.svg';

import { AuthContext } from '../context/AuthContext';
import { ProjectsContext } from '../context/ProjectsContext';
import { NotificationsContext } from '../context/NotificationsContext';

import { logoutUser, firebaseAuth } from '../firebase';
import SearchForm from './HeaderSearch';
import Notifications from './HeaderNotifications';

import db from "../firebase";
import { doc, onSnapshot, collection } from "firebase/firestore";

export default function Header() {

    const { user } = useContext(AuthContext);
    const { projects, setProjects } = useContext(ProjectsContext);
    const { notifications, setNotifications } = useContext(NotificationsContext);

    //===============================================
    // user dropdown

    const [dropdown, setDropdown] = useState(false);
    const toggleDropdown = () => {
        setDropdown(!dropdown);
    }

	// click outside the dropdown => hide dropdown

	useEffect(() => {
		const page = document.querySelector('.page');
		page.addEventListener("click", function(event){
			var container =  document.querySelector('.user');
			if (!(container.contains(event.target) && event.target !== container))
				setDropdown(false);
		});
	});

    const exit = () => {
        setNotifications(false);
        setProjects(false);
        logoutUser();
    }
    
    return (
    
        <header>
            <div className="content">
        
                <NavLink to="/" className="logo"></NavLink>
                <SearchForm />
                
                {/*
                <div className="event">
                    <EventSvg />
                    Event
                </div>
                */}
                
                <div className="personal">

                    <Notifications />

                    <div className={"user" + (dropdown ? " active" : "")}>

                        <div className="email" onClick={toggleDropdown}>
                            {/*{ user && user.account }*/}
                            <PersonSvg/>
                            <div className="email-address">
                                {user.email}
                            </div>
                            <DropdownSvg className="arrow" />
                        </div>

                        <div className="dropdown">
                            <NavLink to="/profile">
                                Edit profile
                            </NavLink>
                            <div onClick={()=>{exit()}}>
                                Exit
                            </div>
                        </div>

                    </div>
                </div>
                
                <div className="logout" onClick={()=>{exit()}}>
                    <LogoutSvg />
                </div>
                
            </div>
        </header>
        
    )
        
}


